export namespace PriceCollectedTime {
  export type Response = {
    priceCollectedTime: PriceCollectedTime;
  };
}

export type PriceCollectedTime = {
  priceCollectedTimestamp: string;
};
